export enum PlayingAge {
  PlayingAgeMinYrs = 3,
  PlayingAgeMaxYrs = 99,
  YPPlayingAgeMinYrs = 0,
  YPPlayingAgeMinMth = 6,
}
